import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    warningContainer: {
      minHeight: '40px',
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
      padding: '8px',
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 98,
      borderBottom: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      position: 'fixed',
      left: 0,
      boxSizing: 'border-box',
    },
    warningText: {
      color: STYLE.COLOR.TEXT1,
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
    },
    warningIcon: {
      marginRight: '8px',
      display: 'flex',
      alignItems: 'center',
    },
  }),
);
